<template>
  <span>
    <v-menu
        bottom
        left
        offset-y
        origin="bottom left"
        transition="fab-transition" 
        :close-on-content-click="false"
        v-model="inMenuAberto"
      >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="100"
          bottom
          text
          @click="inMenuAberto=!inMenuAberto" 
        >
          <v-badge
            color="red"
            overlap
            bordered
          >
            <template v-slot:badge>
              <span>{{notificacoes.length}}</span>
            </template>

            <v-icon medium color="success darken-2">mdi-bell</v-icon>
            <div class="mx-2"></div>
          </v-badge>
        </v-btn>
      </template>

       <!--<h3 class="title is-3">
          Width: {{ window.width }} px<br/>
          Height: {{ window.height }} px
      </h3> -->

      <v-card class="d-flex justify-center" color="success darken-3" >
        <v-btn color="white" text @click="inMenuAberto=!inMenuAberto"> Fechar </v-btn>
      </v-card>

      <v-card class="overflow-y-auto overflow-x-hidden" v-if="!notificacoes.length" min-height="200px">
        <v-card
          class="d-flex justify-center mx-0 my-0 px-0 py-0"
          color="success darken-2"
          dark
          :max-width="cardW"
          :min-width="cardW"
          min-height="200px"
        >
          
          <v-card-text class=" d-flex justify-center align-self-lg-center h6 font-weight-bold my-2 py-2">
            <v-row class="mx-0 d-flex justify-center">
              <span class="h4 font-weight-bold"> Nenhuma Notificação </span>
            </v-row>

          </v-card-text> 
        </v-card>
      </v-card>

      <v-card class="overflow-y-auto overflow-x-hidden" style="max-height: 80vh" v-if="notificacoes.length">

        <transition-group name="list-complete">
          
          <template v-for="(item, i) in notificacoes">

            <v-divider
              v-if="i !== 0"
              :key="`${i}-divider`"
            ></v-divider>

            <v-list-item
              :key="`${i}-${item.id}`"
              class="list-complete-item"
            >
                <v-card
                  class="mx-0 my-0 px-0 py-0"
                  color="success darken-2"
                  dark
                  :max-width="cardW"
                  :min-width="cardW"
                  v-show="!item.dt_confirmacao"

                >
                  
                  <v-card-text class="h6 font-weight-bold my-2 py-2">
                    <v-row class="mx-0">
                      <span class="white--text"> Segurado: {{item.cliente}} </span>
                    </v-row>
                    <v-row class="mx-0">
                      <span class="white--text"> Processo: {{item.tipoprocesso}} / {{item.categoria}} </span> 
                    </v-row>

                  </v-card-text> 

              
                  <v-row
                    class="mx-0 my-0 py-0"
                  >
                    <v-col class="my-0 py-0">
                      <v-textarea
                        class="overflow-y-auto my-0 py-0 text-subtitle-2"
                        label="Notificação"
                        outlined
                        rows="3"
                        row-height="25"
                        readonly
                        :hide-details="true"
                        :value="item.ds_notificacao"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-card-actions class="pt-0 mt-0 mb-0 pb-0">
                    <v-row class="pt-0 mt-0 pb-0 mb-0">
                      <v-col cols="12" sm="7" class="d-flex align-self-center justify-center justify-md-start ml-0 pl-5 px-1 my-0 py-1">
                        <span class="white--text"> {{ item.dt_notificacao | datahora }} </span>
                        <v-icon v-show="item.atrasado ? item.atrasado : false" class="mx-2" size="20" color="red" medium center>mdi-clock-outline</v-icon>
                        
                      </v-col>
                      <v-col class="d-flex align-self-start align-self-md-center justify-center justify-md-end mx-0 px-1 my-0 pb-2" cols="12" sm="4">
                        <v-btn icon @click.stop="marcarLido(item, i)" :loading="item.loading" :disabled="item.loading">
                          <v-icon class="mr-1" size="20" v-show="!item.dt_confirmacao">
                            mdi-checkbox-blank-outline 
                          </v-icon>
                          <v-icon class="mr-1" size="10" medium v-show="item.dt_confirmacao">
                            mdi-checkbox-marked-outline
                          </v-icon>
                        </v-btn>
                        <span class="mr-1">·</span>
                        <v-btn icon @click.prevent="abrirProcesso(item)" :loading="item.loading" :disabled="item.loading" v-show="privilegioNotificaoProcesso">
                          <v-icon class="mr-1">
                            mdi-eye
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card> 
            </v-list-item>
          </template>
        </transition-group>
      </v-card>

    </v-menu>


    <v-row justify="center">
      <v-dialog v-model="dialog" scrollable persistent width="1024px">
        <cadastro-processo ref="formCadastroProcesso" :isExibirNotif="true" @close="dialog=false" v-if="dialog"></cadastro-processo>         
      </v-dialog>
    </v-row>

  </span>
  
</template>

<script>

import {mapGetters, mapState, mapActions, mapMutations} from 'vuex'
import cadastroProcesso from "@/views/Processo/CadastroProcesso"
import utils from '@/mixins/utils'
import privilegiosUsuario from "@/utils/privilegiosUsuario"


export default {
  name: 'Notificacoes',
  components: {
    cadastroProcesso,
  },
  mixins:[utils],
  data: () => ({
    dialog: false,
    loading: false,
    notificacoes: [],
    tituloCadastro: 'Cadastro de Processo de Sinistro',
    cardW: 250,
    alignHour: 'left',
    alignButtons: 'end',
    inMenuAberto: false,
    window: {
        width: 0,
        height: 0
    }
  }),
  created() {
    this.buscarNotificacoes()
    this.continuaBuscando()
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      actUsuarioSelecionado: 'usuario/USUARIO_SELECTED',
      actResetUsuarioSelecionado: 'usuario/RESET_SELECTED',
      resetProcessoSelecionado: 'processo/RESET_SELECTED',
      processoSelecionado: 'processo/PROCESSO_SELECTED',
      actloadDropDownTipoProcessos: 'tipoprocesso/LOAD_DROPDOWN',
      actloadDropDownStatusProcesso: 'statusprocesso/LOAD_DROPDOWN',
      actloadDropDownCategoria: 'categoria/LOAD_DROPDOWN',
      actDropDownColaborador: 'colaborador/LOAD_DROPDOWN',
      buscarNotificacoesApi: 'notificacao/GET_NOTIFICACOES_USU',
      actStoreNotificacao: 'notificacao/STORE_NOTIFICACAO',
      actConfirmaLeitura: 'notificacao/CONFIRMA_VIZUALIZACAO'
    }),
    ...mapMutations({
      commitMostrarSheet: 'system/SET_MOSTRAR_SHEET',
      commitMsgSheet: 'system/SET_MSG_SHEET',
    }),
    mostraMenu(value) {
      this.inMenuAberto = false
      return value
    },
    async buscarNotificacoes() {
      this.loading = true
      try {
        let arrayNotif = await this.buscarNotificacoesApi()
        this.mesclaArray(arrayNotif.notificacoes)
      } catch(e) {
      } finally {
        this.loading = false
      }
    },
    async continuaBuscando() {
      setInterval(async() => {
        this.loading = true
        try {
          let arrayNotif = await this.buscarNotificacoesApi()
          this.mesclaArray(arrayNotif.notificacoes)
        } catch(e) {
        } finally {
          this.loading = false
        }
      }, 120 * 1000);
    },
    mesclaArray(payload) {
      let arrayFilter = JSON.parse(JSON.stringify(payload.filter(item => !item.dt_confirmacao)))

      arrayFilter.forEach((item) => {

        var inExiste = false
        this.notificacoes.forEach((notif) => {
          if (notif.id == item.id) {
            inExiste = true
            return
          }
        })

        if (!inExiste) {
          item.atrasado = this.dataNotificacaoAtrasada(item.dt_notificacao)
          item.loading = false
          this.notificacoes.push(item)
        }

      })

      this.notificacoes.sort((a,b) => (a.dt_notificacao > b.dt_notificacao) ? 1 : ((b.dt_notificacao > a.dt_notificacao) ? -1 : 0))      

    },
    marcarLido(item, index) {
      item.loading = true
      this.actConfirmaLeitura(item)
      .then(resp => {
        this.notificacoes.splice(index, 1)
      })
      .catch(e => {
        console.log('Erro ao marcar notificacao como vizualizado', e)
      })
      .finally(() => item.loading = false)
    },
    async abrirProcesso(item) {
      this.commitMostrarSheet(true)
      this.commitMsgSheet("Aguarde enquanto buscamos o processo para você.")
      this.loading = true
      this.inMenuAberto = false
      await this.actloadDropDownTipoProcessos()
      await this.actloadDropDownStatusProcesso()
      await this.actloadDropDownCategoria()
      await this.actDropDownColaborador()
      try {
        this.resetProcessoSelecionado()
        await this.processoSelecionado(item.processo_id)
        this.tituloCadastro = 'Alteração de Processo de Sinistro'
        this.dialog = true
      } catch(e) {
      } finally {
        this.loading = false
        this.commitMostrarSheet(false)
      }
    },
    async fecharModal () {
      if (await this.$refs.formCadastroProcesso.formFoiAlterado()) {
        this.$dialog.confirm("Dados foram alterados. Deseja fechar e perder alterações?", {loader: true, okText: 'Sim', cancelText: 'Não',})
        .then(async (dialog) => {
          try {
            this.dialog = false
          } finally {
            dialog.close();
          }
        })
      } else {
        this.dialog = false
      }
    },
    callGravar () {
      this.$refs.formCadastroProcesso.gravar()
    },
  
    dataNotificacaoAtrasada(dateTimeItem) {

      if (this.dataValida(dateTimeItem)) return false
      dateTimeItem = this.$moment(dateTimeItem)
      let nowTime = this.$moment(new Date()).subtract(1, 'days')

      //console.log('Data Notif', this.$moment(dateTimeItem).toString())
      //console.log('Data agora', this.$moment(nowTime).toString())

      return dateTimeItem.startOf('day').isBefore(nowTime.startOf('day'));
    },
    handleResize() {
        this.window.width = window.innerWidth
        this.window.height = window.innerHeight
        if (this.window.width < 600) {
          this.alignHour = 'center'
          this.alignButtons = 'center'
        } else {
          this.alignHour = 'left'
          this.alignButtons = 'end'
        }

        if (this.window.width < 600) {
          this.cardW = 300
        } else if (this.window.width < 500) {
          this.cardW = 200
        } else {
          this.cardW = 350
        }
    }
  },
  computed:{
    ...mapState({
      email: state => state.login.user.ds_email,
      id: state => state.login.user.id,
      avatar: state => state.login.user.avatar,
    }),
    ...mapState('processo', [
      'loadingStore',
      'stateButton'
    ]),
    ...mapGetters({
      getNotificacoes: 'notificacao/GET_NOTIFICACOES_USU'
    }),
    privilegioNotificaoProcesso() {
      return privilegiosUsuario.permitirNotificacaoProcesso()
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  
}
</script>

<style scoped>

  .v-btn .v-icon {
    font-size: 2.1rem !important;
  }

 /* .list-leave-active {
    transition: all 0.5s;
    opacity: 0;
  } */

  .v-text-field__details {
    display: none !important;
  }

  .v-messages {
    display: none !important;
  }
 
  .list-complete-item {
    transition: all 1.0s;
    background-color: #00584f !important;
    border-color: #00584f !important;
    padding: 0;
    margin: 0;
  }

  .list-complete-enter, .list-complete-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
  .list-complete-leave-active {
    position: absolute;
  }

  
</style>


// WEBPACK FOOTER //
// src/components/core/Notificacoes.vue